import React from "react";
import { Box } from "@towersystems/towersystems-design-system";
import { map, compact } from "lodash";
import FormRadiosBar from "components/forms/form-radios-bar";
import { noop } from "lodash";
import {
  chartConfig,
  getTypes,
} from "../../modules/report-builder/select-chart-type";

export function SelectChartType({ selected, dataType = "", onChange = noop }) {
  const handleOnChange = (e) => {
    onChange(e.target.value);
  };

  return (
    <Box>
      <Box>
        <FormRadiosBar
          isThumbnail
          onChange={handleOnChange}
          checked={selected}
          items={compact(
            map(getTypes(dataType), (type) => {
              return chartConfig[type];
            })
          )}
        />
      </Box>
    </Box>
  );
}
